module.exports = __webpack_public_path__ + "images/zhongduan2.jpg?v=4b336fbf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/index/zhongduan2.jpg
 ** module id = 115
 ** module chunks = 1 2
 **/